<template>
  <v-slide-y-transition mode="out-in">
    <div id="coa-forms">
      <v-card pa-0>
        <v-toolbar card dark v-bind:color="kompetisi ? kompetisi.color:'black'">
          <v-toolbar-title class="white--text">{{dapil ? dapil.name : null}}</v-toolbar-title>
        </v-toolbar>        
        <v-toolbar card color="white">
          <v-text-field
          flat
          solo
          prepend-icon="search"
          placeholder="Type something"
          v-model="search"
          hide-details
          ></v-text-field>     
          <!--<v-btn icon>
            <v-icon>filter_list</v-icon>
          </v-btn>-->
          <router-link v-bind:to="{path: formPath, query:{
                kompetisi_id: $route.query.kompetisi_id, 
                mode: $route.query.mode,  
                dapil_id: $route.query.dapil_id}}">
              <v-btn color="success" fab small dark>
                <v-icon>add</v-icon>
              </v-btn>  
          </router-link>            
        </v-toolbar>
        <v-divider></v-divider>
        <v-card-text v-model="calons" class="pa-0 dapil-scroll">
          <v-data-table
            :headers="complex.headers"
            :search="search"
            :items="complex.items"
            :loading="loading"
            :pagination.sync="pagination"
            :rows-per-page-items="[25,50,{text:'All','value':-1}]"
            class="elevation-1"
            hide-actions
            item-key="id"                            
            v-model="complex.selected"
            >
            <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>  
            <template slot="items" slot-scope="props"> 
              <tr @click="calonRoute(props.item.id)" style="cursor: pointer">                
                <td style="width:1px;">
                  <v-chip v-bind:color="props.item.color" dark>{{ props.item.no }}</v-chip>
                </td>
                <td>{{ props.item.akronim }}</td>                
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>        
    </div>
  </v-slide-y-transition>
</template>

<script>  
import Model from '@/apps/frc/models/Calon';    

var model = new Model();

export default {
    $_veeValidate: {
      validator: 'new'
    },    
    data: () => ({
        kompetisi_id : null,
        dapil_id : null,
        formPath : '/calon/form',
        search   : '',
        loading  : true,
        pagination: {},
        complex  : {
            selected: [],
            headers: [
              { text: 'No', value: 'no'  },
              { text: 'Partai', value: 'akronim'},              
            ],
            items: []
        },
    }),  
    mounted(){  }, 
    asyncComputed: { 
        kompetisi(){
            this.loading = true;
            this.kompetisi_id = this.$route.query.kompetisi_id;
            return model.kompetisi({id:this.kompetisi_id}).then(res=>{                
                return res;
            });
        }, 
        dapil(){
            this.loading = true;
            this.dapil_id = this.$route.query.dapil_id;
            return model.dapil({id:this.dapil_id}).then(res=>{                
                return res;
            });
        }, 
        calons(){
            this.loading = true;
            this.kompetisi_id = this.$route.query.kompetisi_id;
            this.dapil_id     = this.$route.query.dapil_id ? this.$route.query.dapil_id : null;
            return model.all({'CalonSearch[kompetisi_id]':this.kompetisi_id,
                'CalonSearch[dapil_id]':this.dapil_id,
            }).then(res=>{             
                this.complex.items = res;
                this.loading = false;
                return res;
            });
        }        
    },
    created () {
        if( model.vuex ){
            var context = this;        
            context.$store.watch(
                function (state) { return state },
                function () { model.all().then(data => { context.complex.items = data }) },{ deep: true }
            );                                     
        }
    },
    methods: {      
        format(tgl) { return this.$moment(tgl).format('DD-MM-YYYY')},
        
        init(){
            if(this.$route.query.flag){ 
                Object.assign(this.pagination, {sortBy : 'flag', descending:true});
            }
            model.all().then(data => {      
                this.complex.items = data; 
                this.loading = false;
            });                                         
        },
                     
        firstLetter (name) {            
            return name ? name.charAt(0): null;
        },
        
        calonRoute (id) {
            this.$router.push({path:'/calon', query: {
                kompetisi_id: this.$route.query.kompetisi_id, 
                mode: this.$route.query.mode,  
                dapil_id:this.$route.query.dapil_id,
                id:id
            }});
        },
    }
}
</script>
